<footer
  class="footer"
  [class.footer--show-border-top]="isShowingActions()"
  (pointerup)="onInteractionEnd()"
>
  <div class="footer__wrapper">
    <div class="footer__info">
      <span class="footer__chapter" nrEllipsis>{{ chapterTitle() }}</span>
      <span class="footer__percentage">{{ displayPercent() }}%</span>
    </div>
    <nr-range-slider
      class="footer__slider"
      [class.fade-out]="footerActionsClass().fadeOut"
      [formControl]="sliderControl"
      [ariaLabel]="'PROGRESS_SLIDER' | translate"
      [min]="0"
      [max]="100"
      [tooltipText]="displayPercent() + '%'"
      [forceDisabled]="isSliderDisabled()"
      (keyup)="onInteractionEnd()"
    />
    <div
      class="footer__actions desktop-hidden"
      [class.fade-out]="footerActionsClass().fadeOut"
      [class.element-hidden]="footerActionsClass().elementHidden"
    >
      <div class="footer__actions-buttons">
        <odl-button
          [description]="'HEADER.CONTENTS_AND_BOOKMARKS' | translate"
          id="footer-navigation-button"
        >
          <odl-icon name="list" slot="only-icon" />
        </odl-button>
        <odl-tooltip for="#footer-navigation-button">
          {{ 'HEADER.CONTENTS_AND_BOOKMARKS' | translate }}
        </odl-tooltip>
        <odl-popover
          #navigationPopover
          autoupdate
          class="footer-navigation-popover"
          [attr.for]="'#footer-navigation-button'"
          placement="top"
        >
          <nr-navigation-tabs (nrNavigated)="navigationPopover.open = false"></nr-navigation-tabs>
        </odl-popover>

        <odl-button id="footer-reader-config" [description]="'HEADER.STYLE_SETTINGS' | translate">
          <odl-icon name="font" slot="only-icon" />
        </odl-button>
        <odl-tooltip for="#footer-reader-config">
          {{ 'HEADER.STYLE_SETTINGS' | translate }}
        </odl-tooltip>
        <odl-popover
          autoupdate
          class="reader-settings-wrapper"
          [attr.for]="'#footer-reader-config'"
          placement="top"
        >
          <nr-reader-settings-tabs></nr-reader-settings-tabs>
        </odl-popover>

        @if (featureFlags.isEnabled('finder')()) {
          <odl-button [description]="'SEARCH' | translate" id="footer-search-button">
            <odl-icon name="search" slot="only-icon" />
          </odl-button>
          <odl-tooltip for="#footer-search-button">
            {{ 'SEARCH' | translate }}
          </odl-tooltip>
        }

        @if (featureFlags.hasAnyMoreOption()) {
          <odl-button
            id="footer-more-options-button"
            [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
          >
            <odl-icon name="more_vert" slot="only-icon" />
          </odl-button>
          <odl-tooltip for="#footer-more-options-button">
            {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
          </odl-tooltip>
        } @else {
          <odl-button
            id="footer-fullscreen-button"
            [description]="
              (fullscreenService.isFullscreen() ? 'EXIT_FULLSCREEN' : 'FULLSCREEN') | translate
            "
            (click)="fullscreenService.toggle()"
          >
            <odl-icon
              [name]="fullscreenService.isFullscreen() ? 'fullscreen_exit' : 'fullscreen'"
              slot="only-icon"
            />
          </odl-button>
          <odl-tooltip for="#footer-fullscreen-button">
            {{ (fullscreenService.isFullscreen() ? 'EXIT_FULLSCREEN' : 'FULLSCREEN') | translate }}
          </odl-tooltip>
        }
      </div>
    </div>
  </div>
</footer>
